exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "html{height:100%}body,body>#___gatsby{height:100%;width:100%;background-color:#f5f5f5}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./src/layouts/base.css
// module id = ./src/layouts/base.css
// module chunks = 1